// extracted by mini-css-extract-plugin
export default {"DocumentSelectionDropdown":"DocumentSelection_DocumentSelectionDropdown__KEl3L"};